<template>
  <div class="full">
    <div :id="`mapOnlyCurrent-${current}`" class="full"></div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "google-map-only-current",
  props: {
    current: { type: String, default: false, required: true },
  },
  computed: {
    ...mapState(["search", "currentLat", "currentLng", "currentPageName"]),
  },
  data() {
    return {
      map: null,
      currentMarker: undefined,
    };
  },
  methods: {
    ...mapMutations([
      "setDepLatLng",
      "setDesLatLng",
      "loadingStartMini",
      "loadingEndMini",
      "setMap",
      "setSearchState",
    ]),
    /**
     * マップのロード
     */
    loadMap() {
      const element = document.getElementById(`mapOnlyCurrent-${this.current}`);
      const latlng = new window.google.maps.LatLng(
        this.currentLat,
        this.currentLng,
      );
      const mapOptions = {
        mapId: "75847128c63f5e96",
        zoom: 12,
        center: latlng,
        gestureHandling: "greedy",
        scaleControl: false,
        mapTypeControl: false,
        zoomControl: false,
        streetViewControl: false,
        fullscreenControl: false,
      };
      this.map = new window.google.maps.Map(element, mapOptions);
      this.setMap(this.map);
      const trafficLayer = new window.google.maps.TrafficLayer();
      trafficLayer.setMap(this.map);
      this.loadingEndMini();
    },
    /**
     * マーカーのセット
     */
    setMarker(position) {
      this.currentMarker = new window.google.maps.Marker({
        position,
        map: this.map,
      });

      this.loadingEndMini();
    },
  },
  mounted() {
    this.loadingStartMini();
    if (this.currentLat && this.currentLng) {
      this.loadMap();
    }
  },
};
</script>

<style scoped>
.google-map {
  width: 100%;
  height: 100px;
  margin: 0 auto;
  background: gray;
}
.full {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/GoogleMapOnlyCurrent.vue